import React from "react";
import RCProgress from "react-progress-2";
import { STYLES } from "../../constants";

function ProgressBar() {
  return (
    <RCProgress.Component
      style={{ background: "#c1c1c1", height: "3px" }}
      thumbStyle={{ background: STYLES.color.blue, height: "3px" }}
    />
  );
}

const Progress = RCProgress;
Progress.Bar = ProgressBar;

export default Progress;
